/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('../bootstrap');

import Vue from 'vue'

/**
 * アプリ設定
 */

// アプリ設定をmetaタグから取得
Vue.prototype.$config = JSON.parse(document.head.querySelector('meta[name="app-config"]').content);

// axiosのベースURLをmetaタグから取得
axios.defaults.baseURL = document.head.querySelector('meta[name="api-base-url"]').content;

/**
 * Sentryによるエラーロギング
 * できる限り早い段階で設定する
 */

import * as Sentry from "@sentry/vue";
import {Integrations} from "@sentry/tracing";

// 環境変数にdnsがあればSentryを設定
if (Vue.prototype.$config['sentry']['dsn']) {
    Sentry.init({
        Vue,
        dsn: Vue.prototype.$config['sentry']['dsn'],
        integrations: [
            new Integrations.BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                tracingOrigins: ["localhost", "my-site-url.com", /^\//],
            }),
        ],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
    });
}

// インポート
import router from './router';
import store from "./store";

// グローバルナビゲーションガード
router.beforeEach((to, from, next) => {
    // ログインを要求するルートが含まれ、ログインしていなければログインページに移動
    if (to.matched.some(record => !record.meta.isPublic) && !store.getters['auth/check']) {
        next({
            path: '/member/login',
            query: {redirect: to.fullPath}
        });
    } else {
        next();
    }
});

/**
 * プラグイン
 */

// Toasted
import Toasted from 'vue-toasted';

Vue.use(Toasted, {
    position: 'top-center',
    duration: 5000,
    // fullWidth: true,
    type: 'success',
});

// VuePaginate(laravel-vue-paginationに変更予定)
import VuePaginate from 'vue-paginate';

Vue.use(VuePaginate);

// Laravel Vue Pagination
Vue.component('pagination', require('laravel-vue-pagination'));

// VueBreadcrumbs
import VueBreadcrumbs from 'vue-breadcrumbs';

Vue.use(VueBreadcrumbs);

// axiosCancel
import axiosCancel from 'axios-cancel';

axiosCancel(axios, {
    debug: false // default
});

// VueMoment
const moment = require('moment');
require('moment/locale/ja');
Vue.use(require('vue-moment'), {moment});

// VModal
import VModal from 'vue-js-modal'

Vue.use(VModal);

// Vue Loading Overlay
Vue.component('loading', require('vue-loading-overlay'));
import 'vue-loading-overlay/dist/vue-loading.css';

// VuejsDialog
import VuejsDialog from 'vuejs-dialog';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';

Vue.use(VuejsDialog, {
    html: true,
    reverse: true,
    okText: 'OK',
    cancelText: 'キャンセル',
    animation: "fade",
    backdropClose: true,
});

/**
 * mixinをグローバルに登録
 */
import mixinCommon from '../mixin.js'

Vue.mixin(mixinCommon);

// import mixin from './mixin.js'
//
// Vue.mixin(mixin);

/**
 * Vue App
 */
import App from "./App.vue";

const app = async () => {
    // スタート時にログイン中ユーザを確認
    await store.dispatch('auth/currentUser');

    new Vue(Vue.util.extend({
        router,
        store
    }, App)).$mount('#app');
};

app();
